import toast from "react-hot-toast";

// Shop-styled replacements for window.alert(). Styling lives on <Toaster />
// in index.js so every toast follows the theme (paper/ink, square corners).
export const notifySuccess = (message) => toast.success(message);
export const notifyError = (message) => toast.error(message);
export const notifyInfo = (message) => toast(message);
